<clr-icon shape="layers" [style.color]="tenantName | stringToColor"></clr-icon>
